export default {
  isCreateNote: false,
  note: {
    noteType: "",
    noteTitle: "",
    noteTxt: "",
  },
};
